module.exports = __webpack_public_path__ + "img/best-employee.ce57f774.svg";